import React, { PureComponent } from 'react';
import cls from 'classnames';
import { Tooltip } from 'antd';
import Utils from '../Utils/utils';
import * as svg from './img';

class Icon extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      btnClass: '',
    };
  }

  render() {
    const {
      type,
      id,
      onClick,
      color,
      opacity,
      role,
      btnType,
      titleText,
      className,
      href,
      theme,
      width,
      height,
      style,
      tooltipProps,
      ...other
    } = this.props;

    const IconComp = svg[Utils.toPascalCase(type)];

    if (role === 'button') {
      return (
        <Tooltip placement="right"
                 title={titleText}
                 arrowPointAtCenter={true}
                 destroyTooltipOnHide={true}
                 {...tooltipProps}>
          <span id={id} onClick={onClick} className={cls('icon-btn', btnType)}>
            {IconComp && (
              <IconComp theme={theme} className={cls('icon', className)} {...other} opacity={opacity} color={color}
                        width={width} height={height} />
            )}
          </span>
        </Tooltip>
      );
    }
    if (role === 'icon') {
      return (
        <IconComp className={className}
                  onClick={onClick}
                  opacity={opacity}
                  color={color}
                  type={type}
                  width={width}
                  height={height}
                  style={style}
                  {...other}
        />
      );
    }

    return (
      <a id={id}
         href={href}
         target="_blank"
         rel="noopener noreferrer"
         onClick={onClick}
         style={{
           display: 'flex',
           alignItems: 'center',
         }}
         onMouseEnter={() => this.setState({ btnClass: 'hover-btn' })}
         onMouseLeave={() => this.setState({ btnClass: '' })}
      >
        {
          IconComp && (
            <IconComp className={this.state.btnClass}
                      onClick={onClick}
                      opacity={opacity}
                      color={color}
                      type={type}
            />
          )}
      </a>
    );
  }
}

export default Icon;
